import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-ofers-catalog-list',
	templateUrl: './ofers-catalog-list.component.html',
	styleUrls: ['./ofers-catalog-list.component.css'],
})
export class OfersCatalogListComponent extends ListComponent {
	protected apiUrl = 'offer/catalog';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [{ id: 'name', name: 'Nazwa' }];

	parameters = {
		id: null,
		offset: null,
		search: null,
	};

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/15/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}

	protected loadData(): void {
		this.bag.get('/' + this.apiUrl + '/?limit=9999', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.data = this.convertData(result);
			this.loader.hide();
		});
	}
}
